import { Stack } from "@/core/components/ui/stack";
import { TabsListWithIndicator, TabsTrigger } from "@/core/components/ui/tabs";

export const MANUAL_EDITS_TAB = {
  all: "all",
  review: "review",
  applied: "applied",
  added: "added",
} as const;

export type ManualEditsTab =
  (typeof MANUAL_EDITS_TAB)[keyof typeof MANUAL_EDITS_TAB];

export interface ManualEditsTabCounts {
  all: number;
  review: number;
  applied: number;
  added: number;
}

const TAB_LABELS = {
  [MANUAL_EDITS_TAB.all]: "All",
  [MANUAL_EDITS_TAB.review]: "To review",
  [MANUAL_EDITS_TAB.applied]: "Applied",
  [MANUAL_EDITS_TAB.added]: "Added",
} satisfies Record<ManualEditsTab, string>;

// "All" always shows. The other tabs only show when they have content.
export const visibleManualEditsTabs = (
  counts: ManualEditsTabCounts,
): ManualEditsTab[] =>
  [
    MANUAL_EDITS_TAB.all,
    MANUAL_EDITS_TAB.review,
    MANUAL_EDITS_TAB.applied,
    MANUAL_EDITS_TAB.added,
  ].filter((tab) => tab === MANUAL_EDITS_TAB.all || counts[tab] > 0);

interface ManualEditsTabsProps {
  tabs: ManualEditsTab[];
  counts: ManualEditsTabCounts;
}

export const ManualEditsTabs = ({ tabs, counts }: ManualEditsTabsProps) => (
  // Four tabs plus their counts is a tight fit at the sidebar's width, so the
  // triggers run narrower than the app's default.
  <Stack className="shrink-0 border-b border-stroke-tertiary">
    <TabsListWithIndicator size="small" hideBottomBorder>
      {tabs.map((tab) => (
        <TabsTrigger key={tab} value={tab} count={counts[tab]} className="px-3">
          {TAB_LABELS[tab]}
        </TabsTrigger>
      ))}
    </TabsListWithIndicator>
  </Stack>
);
